// Built by hand on the server, not a serialized entity: no serialization group applies.
export type AiProviderConnectionTestPayload = {
	readonly succeeded: boolean;
	readonly message: string;
	readonly testedAt: string;
	// Empty on failure just as much as on "this provider exposes no listing": never infer the absence
	// of models from an empty array.
	readonly models: string[];
};

// The response carries no provider identifier: connection-test responses are hand-built objects, not
// serialized entities, so `providerId` travels beside the payload, next to `accountId`, the same way
// route-scope identifiers already do for other actions in this layer.
export type AiProviderConnectionTestedAction = {
	type: 'AI_PROVIDER_CONNECTION_TESTED';
	payload: AiProviderConnectionTestPayload;
	accountId: number;
	providerId: number;
};

export default (
	payload: AiProviderConnectionTestPayload,
	accountId: number,
	providerId: number,
): AiProviderConnectionTestedAction => ({
	type: 'AI_PROVIDER_CONNECTION_TESTED',
	payload,
	accountId,
	providerId,
});
